import React from 'react';
import classNames from 'classnames';
import { ChevronSmallRight } from '@s7/ui-kit/icons';
import styles from './show-more.css';
export var ShowMore = React.memo(function (_a) {
    var _b;
    var text = _a.text, link = _a.link, openInNewTab = _a.openInNewTab, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, className = _a.className;
    if (!text || !link) {
        return null;
    }
    return React.createElement("a", { href: link, onClick: onClick, target: openInNewTab ? '_blank' : '_self', rel: openInNewTab ? 'noopener noreferrer' : '', className: classNames((_b = {},
            _b[styles.container] = true,
            _b[className] = !!className,
            _b)) },
        React.createElement("p", { className: styles.text, dangerouslySetInnerHTML: {
                __html: text
            } }),
        React.createElement("div", { className: styles.icon },
            React.createElement(ChevronSmallRight, null)));
});
